"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _requestAccess = require("modals/requestAccess");

var _decorators = require("decorators");

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _react = babelHelpers.interopRequireDefault(require("react"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PrositeRequestAccess = /*#__PURE__*/function (_Block) {
  babelHelpers.inherits(PrositeRequestAccess, _Block);

  var _super = _createSuper(PrositeRequestAccess);

  function PrositeRequestAccess() {
    babelHelpers.classCallCheck(this, PrositeRequestAccess);
    return _super.apply(this, arguments);
  }

  babelHelpers.createClass(PrositeRequestAccess, [{
    key: "getChildren",
    value: function getChildren() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content-container"
      }, /*#__PURE__*/_react.default.createElement(_requestAccess.RequestAccess, null));
    }
  }]);
  return PrositeRequestAccess;
}(_base.default);

exports.default = PrositeRequestAccess;